import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InteractionsMetadataVisibilityResponse } from '@app/models';
import { Observable } from 'rxjs';
import { BaseServiceClass } from './baseService.service';

@Injectable({ providedIn: 'root' })
export class InteractionsMetadataVisibilityService extends BaseServiceClass<InteractionsMetadataVisibilityResponse> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/api/v1/interactions-metadata-visibility');
  }

  updateVisibility(id: number, visibility: boolean): Observable<InteractionsMetadataVisibilityResponse> {
    return this.httpService.put<InteractionsMetadataVisibilityResponse>(
      `${this.entity_url}/${id}/visibility`,
      { visibility }
    );
  }
}


